export type AgencyListStateProps = {
  title: string
  message: string
}

export function AgencyListLoading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div
      aria-live="polite"
      aria-busy="true"
      className="border-2 border-line bg-surface px-6 py-10 text-center"
    >
      <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted">
        {label}
      </p>
    </div>
  )
}

export function AgencyListError({ title, message }: AgencyListStateProps) {
  return (
    <div
      role="alert"
      className="border-2 border-accent bg-accent-soft px-6 py-10 text-center"
    >
      <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-accent">
        {title}
      </p>
      <p className="mt-2 text-sm text-accent">{message}</p>
    </div>
  )
}
